import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import { translations } from '../../translations';

interface NotFoundProps {
  isDarkMode: boolean;
  language: string;
}

export function NotFound({ isDarkMode, language }: NotFoundProps) {
  const navigate = useNavigate();
  const t = translations[language as keyof typeof translations];

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="text-center">
        <div className="relative">
          <img
            src="https://images.unsplash.com/photo-1594322436404-5a0526db4d13?q=80&w=2429&auto=format&fit=crop"
            alt="404"
            className="w-full max-w-lg h-64 object-cover rounded-2xl"
          />
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm rounded-2xl" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className={`text-7xl font-bold text-white`}>404</h1>
          </div>
        </div>

        <div className="mt-8">
          <h2 className={`text-2xl font-semibold mb-2 ${
            isDarkMode ? 'text-gray-200' : 'text-gray-900'
          }`}>
            {t.page_not_found}
          </h2>
          <p className={`text-sm mb-8 ${
            isDarkMode ? 'text-gray-400' : 'text-gray-600'
          }`}>
            {t.page_not_found_description}
          </p>

          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() => navigate(-1)}
              className={`px-4 py-2 rounded-lg text-sm font-medium flex items-center gap-2 transition-colors ${
                isDarkMode
                  ? 'bg-[#2b2b2b] text-gray-300 hover:bg-[#333333]'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              <ArrowLeft size={16} strokeWidth={2} />
              {t.go_back}
            </button>
            <button
              onClick={() => navigate('/')}
              className="px-4 py-2 bg-orange-500 text-white rounded-lg text-sm font-medium flex items-center gap-2 hover:bg-orange-600 transition-colors"
            >
              <Home size={16} strokeWidth={2} />
              {t.return_home}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}